import Checkout from './Checkout';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './Checkout.state';

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
